import React from 'react';
import ReactDOM from 'react-dom';
import PebbleBeachPartnerPage from '../pages/PebbleBeachPartnerPage';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <PebbleBeachPartnerPage />,
    document.body.appendChild(document.createElement('div')),
  )
});
